module.exports = __webpack_public_path__ + "static/img/v60.f58ff90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v60.png
// module id = LY+g
// module chunks = 1